import { Text } from '@ksyos/design-system';
import { ManagerAuthorization } from '@common/enums';
import { translateKey } from '@frontend/translate';
import { hasOneAuthorization } from '@frontend/utils';
import { GgzAvailabilitySettings } from './GgzAvailabilitySettings';
import { GgzConsultContactDetails } from './GgzConsultContactDetails';

interface IGgzConsultationPersonalSettingsProps {
    employmentId: string;
    isReadOnly: boolean;
    serviceConsumerId: string;
}

export function GgzConsultationPersonalSettings(props: IGgzConsultationPersonalSettingsProps) {
    const hasEmploymentSettingsReadAuthorization = hasOneAuthorization(ManagerAuthorization.employmentSettingsRead);

    return (
        <>
            <Text
                my={8}
                size="md"
            >
                {hasEmploymentSettingsReadAuthorization
                    ? translateKey('personalSettings.ggz.phoneAvailabilityExplanationAsAccountManager')
                    : translateKey('personalSettings.ggz.availabilityExplanation')}
            </Text>
            <GgzConsultContactDetails {...props} />
            <GgzAvailabilitySettings {...props} />
        </>
    );
}
